<!-- Title -->
<div class="text-center">
  <h1>Pre-evaluation</h1>
</div>

<!-- Pre-Evaluation Survey Content -->
<div id="pre-evaluation-survey">

  <div class="container content-box module-content">
    <p>Before you start this RentWise educational program, we would like to know more about what information would
      be most helpful to you and what you may already know. This information will us adjust the sessions to meet your
      needs. We also want to evaluate the RentWise courses and materials so that we can make changes to better meet
      renters’ needs. By completing the form, you are agreeing that we can use the information to summarize the
      program.</p>

    <!-- Form -->
    <form name="form" (submit)="f.form.valid && submitForm()" #f="ngForm" novalidate>

      <!-- Question 1 -->
      <section *ngIf="question1 as q" class="question1">
        <p>1. <span [innerHtml]="q.questionWithHints || q.question"></span></p>

        <table class="table table-bordered table-striped" *ngIf="q.answer as table">
          <thead>
            <tr>
              <th scope="col" class="th-question">I know...</th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Nothing<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Very Little<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know Some Things<br>About Topic</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Know a Lot<br>About Topic</span></th>
              <th scope="col" class="th-comments rotated-cell"><span>Any comments?</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let question of table.questions; let qindex=index">
              <tr>
                <td class="td-question" scope="row">{{letter(qindex)}}. {{question}}</td>

                <td class="td-answer text-center" (keypress)="table_radioGroup_keypress(q.answer, qindex, $event)"
                    *ngFor="let option of table.options; let oindex=index">
                  <div class="form-group radio-group" [class.has-error]="f.submitted && radio.invalid">
                    <input type="radio" class="btn-check" name="table{{q.questionNumber}}_options{{qindex}}" id="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}" autocomplete="off"
                      [(ngModel)]="table.answers[qindex]" #radio="ngModel" [value]="option" required>
                    <label class="custom btn" for="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}"
                      [ngClass]="[table.answers[qindex] === option ? 'btn-secondary' : 'btn-outline-secondary']"
                      (click)="table_radio_click(q.answer, option, qindex, $event)">{{option}}</label>
                  </div>
                </td>

                <td class="td-comments">
                  <button type="button" class="custom btn add-comment" (click)="table_toggleComment(q, qindex)"
                      [matTooltip]="ui.comment(table.comments[qindex]).show !== true ? 'Add comments' : 'Remove comments'" [matTooltipShowDelay]="1000">
                    <mdb-icon far icon="comment-alt" class="icon-comment" size="lg"></mdb-icon>
                    <mdb-icon fas icon="plus" class="icon-plus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show !== true"></mdb-icon>
                    <mdb-icon fas icon="minus" class="icon-minus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show === true"></mdb-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="ui.comment(table.comments[qindex]).show">
                <td colspan="6">
                  <textarea class="form-control comments" name="comments" rows="2" placeholder="Enter comments..."
                    [(ngModel)]="ui.comment(table.comments[qindex]).text" [ngModelOptions]="{ standalone: true }">
                  </textarea>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>

      <!-- Question 2 -->
      <section *ngIf="question2 as q" class="question2">
        <p>2. <span [innerHtml]="q.questionWithHints || q.question"></span></p>

        <table class="table table-bordered table-striped" *ngIf="q.answer as table">
          <thead>
            <tr>
              <th scope="col" class="th-question">My experiences as a renter</th>
              <th scope="col" class="th-answer rotated-cell"><span>Strongly<br>Disagree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Disagree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Agree</span></th>
              <th scope="col" class="th-answer rotated-cell"><span>Strongly<br>Agree</span></th>
              <th scope="col" class="th-comments rotated-cell"><span>Any comments</span></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let question of table.questions; let qindex=index">
              <tr>
                <td class="td-question" scope="row">{{letter(qindex)}}. {{question}}</td>

                <td class="td-answer text-center" (keypress)="table_radioGroup_keypress(q.answer, qindex, $event)"
                    *ngFor="let option of table.options; let oindex=index">
                  <div class="form-group radio-group" [class.has-error]="f.submitted && radio.invalid">
                    <input type="radio" class="btn-check" name="table{{q.questionNumber}}_options{{qindex}}" id="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}" autocomplete="off"
                      [(ngModel)]="table.answers[qindex]" #radio="ngModel" [value]="option" required>
                    <label class="custom btn" for="table{{q.questionNumber}}_options{{qindex}}_{{oindex}}"
                      [ngClass]="[table.answers[qindex] === option ? 'btn-secondary' : 'btn-outline-secondary']"
                      (click)="table_radio_click(q.answer, option, qindex, $event)">{{option}}</label>
                  </div>
                </td>

                <td class="td-comments">
                  <button type="button" class="custom btn add-comment" (click)="table_toggleComment(q, qindex)"
                      [matTooltip]="ui.comment(table.comments[qindex]).show !== true ? 'Add comments' : 'Remove comments'" [matTooltipShowDelay]="1000">
                    <mdb-icon far icon="comment-alt" class="icon-comment" size="lg"></mdb-icon>
                    <mdb-icon fas icon="plus" class="icon-plus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show !== true"></mdb-icon>
                    <mdb-icon fas icon="minus" class="icon-minus" size="xs" *ngIf="ui.comment(table.comments[qindex]).show === true"></mdb-icon>
                  </button>
                </td>
              </tr>
              <tr *ngIf="ui.comment(table.comments[qindex]).show">
                <td colspan="6">
                  <textarea class="form-control comments" name="comments" rows="2" placeholder="Enter comments..."
                    [(ngModel)]="ui.comment(table.comments[qindex]).text" [ngModelOptions]="{ standalone: true }">
                  </textarea>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </section>

      <!-- Question 3 -->
      <section *ngIf="question3 as q" class="question3">
        <p>3. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer3" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Question 4 -->
      <section *ngIf="question4 as q" class="question4">
        <p>4. <span [innerHtml]="q.questionWithHints || q.question"></span></p>
        <textarea class="form-control" name="answer4" rows="4" [(ngModel)]="q.answer.text" [ngModelOptions]="{ standalone: true }"></textarea>
      </section>

      <!-- Submit Form -->
      <button type="submit" class="btn waves-dark">Submit <i class="fas fa-angle-right ml-3"></i></button>
    </form>
  </div>
</div>
